import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ForgotPasswordService {
  static requestPasswordLink(email) {
    return HttpUtil.uniterceptedPost(API_ROUTES.FORGOTPASSWORD.REQUESTRESETLINK, email);
  }
 
}
